<template>
  <div v-show="!loading" class="answer-content">
    <div class="answer" v-show="answer">
      <div class="left">
        <div class="icon">答</div>
      </div>
      <div class="right" style="white-space: pre-wrap" ref="answerRef">
        {{ answer }}
        <span class="blink" v-if="streaming">{{ '_' }}</span>
      </div>

      <div class="footer">
        <a-row class="btns">
          <a-col :span="12" class="copy btn" @click="exportMessage">
            <auth-img src="@/assets/img/chat/ai.png" />
            引用至对话框
          </a-col>
          <a-col
            :span="12"
            class="refresh btn"
            v-show="showRefresh"
            @click="() => emit('getAnswer', true)"
          >
            <auth-img src="@/assets/img/ai/refresh.png" />
            重新生成
          </a-col>
        </a-row>
      </div>
    </div>
    <div v-show="!answer" class="empty">
      <auth-img src="@/assets/img/ai/empty.png" />
      <div>暂无对应资料</div>
    </div>
  </div>
  <div v-show="loading" class="loading">
    <div><a-spin :indicator="indicator" tip="努力查询中…" :spinning="loading" /></div>
  </div>
</template>
<script setup>
import { defineProps, h, defineEmits, ref, watch, nextTick, defineExpose } from 'vue'
import { LoadingOutlined } from '@ant-design/icons-vue'
import { requstMethod } from '../useStream'

const emit = defineEmits(['exportMessage', 'getAnswer'])
const answerRef = ref(null)
const streaming = ref(false)
const indicator = h(LoadingOutlined, {
  style: {
    fontSize: '21px'
  },
  spin: true
})
const prop = defineProps({
  loading: {
    type: Boolean,
    default: false
  },
  answer: {
    type: String,
    default: ''
  },
  question_type: {
    type: Number,
    default: 0
  },
  question_id: {
    type: Number,
    default: null
  },
  showRefresh: {
    type: Boolean,
    default: false
  }
})
const exportMessage = () => {
  const { answer, question_type, question_id } = prop
  // 答案采纳反馈
  try {
    const params = {
      url: 'doctor_assistant.html',
      method: 'post',
      query: {
        m: 'feedbacks',
        p: {
          question_type,
          question_id,
          adopt: 1
        }
      }
    }
    requstMethod(params)
      .then(() => {
        //
      })
      .catch(() => {
        //
      })
  } catch {
    //
  }

  emit('exportMessage', answer)
}
watch(
  () => prop.answer,
  val => {
    if (!val) return
    nextTick(() => {
      const scrollHeight = answerRef.value.scrollHeight
      answerRef.value.scrollTop = scrollHeight
    })
  },
  {
    immediate: true
  }
)
const onDispatch = status => {
  streaming.value = status
}
defineExpose({ onDispatch })
</script>
<style scoped lang="scss">
.answer-content {
  padding: 16px 0;
  height: 100%;
  .answer {
    display: flex;
    flex-direction: row;
    position: relative;
    height: 100%;
    .left {
      width: 30px;
      margin-left: 16px;
      .icon {
        width: 20px;
        height: 20px;
        line-height: 20px;
        background: #24bca2;
        border-radius: 6px 6px 0 6px;
        font-weight: 500;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
      }
    }
    .right {
      flex: 1;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      height: 100%;
      padding-bottom: 45px;
      overflow: auto;
      padding-right: 16px;
      /* 定义keyframe动画，命名为blink */
      @keyframes blink {
        0% {
          opacity: 1;
        }

        100% {
          opacity: 0;
        }
      }
      /* 添加兼容性前缀 */
      @-webkit-keyframes blink {
        0% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }
      @-moz-keyframes blink {
        0% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }
      @-ms-keyframes blink {
        0% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }
      @-o-keyframes blink {
        0% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }
      /* 定义blink类*/
      .blink {
        color: #5c92fd;
        font-size: 20px;
        animation: blink 1s linear infinite;
        /* 其它浏览器兼容性前缀 */
        -webkit-animation: blink 1s linear infinite;
        -moz-animation: blink 1s linear infinite;
        -ms-animation: blink 1s linear infinite;
        -o-animation: blink 1s linear infinite;
      }
    }
    .footer {
      position: absolute;
      bottom: 0px;
      left: 0;
      right: 0;
      background-image: linear-gradient(180deg, #ffffff00 0%, #ffffff 42%);
      padding: 34px 16px 0 46px;

      font-weight: 400;
      font-size: 14px;
      .btn {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
      .copy {
        font-weight: 500;
        color: #1890ff;
        justify-content: flex-start;
        img {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
      }
      .refresh {
        color: #24bca2;
        img {
          width: 14px;
          height: 14px;
          margin-right: 4px;
        }
      }
    }
  }
  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    height: 100%;
    img {
      width: 24px;
      margin-bottom: 12px;
    }
  }
}
.loading {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
